import { isInstructorInSpace } from '@core/selectors/classroom';

export const timeFormatter = (
  value: number,
  unit: string,
  suffix: string
): string => {
  if (value <= 60 && unit === 'second') {
    return 'Just now';
  }
  const unitPluralized = value !== 1 ? `${unit}s` : unit;
  return `${value} ${unitPluralized} ${suffix}`;
};

export const getFeedLabel = (feedType: string): string =>
  feedType === 'commonRoom' ? 'Common room' : 'Announcements';

export const isAnnouncementPost = (feedType: string): boolean =>
  feedType === 'announcements';

export const getFullName = (user: {
  firstName?: string;
  lastName?: string;
}): string => {
  const first = user?.firstName || 'User';
  const last = user?.lastName || '';
  return `${first} ${last}`.trim();
};

export const getUserInitials = (user: {
  firstName?: string;
  lastName?: string;
}): string => {
  const first = user?.firstName || 'U';
  const last = user?.lastName || '';
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
};

export const sumReactions = (
  reactionsFromStore: any[],
  fallbackCount?: number
): number => {
  if (typeof fallbackCount === 'number') return fallbackCount;
  return reactionsFromStore.reduce(
    (sum: number, r: any) => sum + (typeof r.count === 'number' ? r.count : 1),
    0
  );
};

/**
 * Returns a Redux selector that resolves to `true` when the author of the
 * given post item is an instructor (educator) in the post's space.
 * Use with `useSelector`: `const isEducator = useSelector(selectIsEducatorPost(item))`.
 */
export const selectIsEducatorPost =
  (item: any) =>
  (state: any): boolean => {
    const authorId = item?.user?.objectId || item?.user?.id;
    const spaceId = item?.classRoom;
    if (!authorId || !spaceId) return false;
    return isInstructorInSpace(state)(authorId, spaceId);
  };
